import { UpdateFormProps } from "./types"
import React, { useState } from "react"
import styled, { useTheme} from '~/ui/styled'
import { editPrompt } from "~utils/prompt"
// import { useTheme } from '~/ui/styled'
import { Button, Text } from "~components/El"
import { Header } from "~components/header"
import { Heading4 } from "~components/heading"
import { InputTextFloatLabel } from "~components/input-text"
import { RadioGroup } from "~components/radio-group"
import { CheckBoxGroup } from "~components/check-box-group"

const Container = styled.View`
  background-color: ${({ theme }) => theme.colors.blockBackground};
  align-items: center;
  padding: 50px 20px 20px;
  flex: 1;
`

const FormItem = styled.View`
  margin-top: 30px;
  margin-bottom: 20px;
  width: 100%;
`

const TitleWrap = styled.View`
  margin-bottom: 10px;
`

const SubTitle = styled.Text`
  color: #121212;
  font-size: 14px;
`

const UpdateForm: React.FC<UpdateFormProps> = ({
  modalPageTitle,
  modalPageSubTitle,
  onLeftPress,
  handleSubmit,
  handleCancel,
  disabledFunc,
  buttonSubmitText = "完成",
  inputs,
  isSubmitConfirm = true,
}) => {
  const theme = useTheme()

  const [values, setValues] = useState(
    inputs.reduce(
      (acc, { key, defaultValue }) => {
        acc[key] = defaultValue
        return acc
      },
      {} as {
        title: string
      },
    ),
  )

  const handleSubmitInner = () => {
    if (isSubmitConfirm) {
      editPrompt({
        onSuccess: () => handleSubmit(values),
        onCancel: handleCancel,
      })
    } else {
      handleSubmit(values)
    }
  }

  return (
    <>
      <Header
        headerRight={
          <Button
            color={theme.colors.primary}
            onClick={handleSubmitInner}
            text={buttonSubmitText}
            disabled={disabledFunc(values)}
          >
            <Text color={theme.colors.primary} fontSize="16px">{buttonSubmitText}</Text>
          </Button>
        }
        onLeftPress={onLeftPress}
      />
      <Container>
        {modalPageTitle !== "" && (
          <TitleWrap>
            <Heading4 text={modalPageTitle} />
          </TitleWrap>
        )}
        {modalPageSubTitle !== "" && <SubTitle>{modalPageSubTitle}</SubTitle>}
        {inputs.map((input, index) => {
          // React 的 key 不能通过 {...props} 传递，否则会有 warning
          const { key: inputKey, ...restInput } = input as any
          return (
            <FormItem key={inputKey || index.toString()}>
              {input.inputType === "text-input" && (
                <InputTextFloatLabel
                  {...restInput}
                  onChangeText={(text) => {
                    setValues({
                      ...values,
                      [inputKey]: text,
                    })
                  }}
                />
              )}
              {input.inputType === "radio-group" && (
                <RadioGroup
                  {...restInput}
                  value={values[inputKey]}
                  setValue={(v) => {
                    setValues({
                      ...values,
                      [inputKey]: v,
                    })
                  }}
                />
              )}
              {input.inputType === "check-box-group" && (
                <CheckBoxGroup
                  {...restInput}
                  value={values[inputKey]}
                  setValue={(v) => {
                    const preValues = values[inputKey]
                    const isPrevValuesIncludeSelectedValue = preValues.includes(v)
                    const newValues = isPrevValuesIncludeSelectedValue
                      ? preValues.filter((pv) => pv !== v)
                      : preValues.concat([v])
                    setValues({
                      ...values,
                      [inputKey]: newValues,
                    })
                  }}
                />
              )}
            </FormItem>
          )
        })}
      </Container>
    </>
  )
}

export default UpdateForm
